<template>
<b-modal id="modalReadCode" hide-footer hide-header no-close-on-backdrop no-close-on-esc @close="close" size="lg">
	<div class="fullscreen" v-if="show">
		
		<Loader :show="loading"></Loader>

		<div class="head">
			<div class="container">
				<div class="btn icon icon-close invert" @click="close"></div>
				<h1>Cargar vehículo</h1>
			</div>
		</div>

		<div class="content">
			<div class="container">
				<div class="mt-4 mb-4">
					<!-- <img :src="require('@/assets/icons/icon-scan.png')"> -->
					<!-- <p class="mt-4 mb-4 text-center">Escanee el código en la etiqueta del vehículo para comenzar el control</p> -->


					<div class="action-buttons mt-4" v-if="!showSearch">
						<a class="btn" @click="openScan()">
							<div class="icon icon-xl icon-scan"></div>
							Escanear código
						</a>
						<a class="btn" @click="openSearch()">
							<div class="icon icon-xl icon-search"></div>
							Buscar por chasis
						</a>
						<a class="btn" @click="setCarReading()" v-if="settings.enableCounts">
							<div class="icon icon-xl icon-register"></div>
							Registrar vehículo
						</a>
						
					</div>

					<div style="max-width:400px; width:100%; margin:auto;" v-if="showSearch">

						<div class="form-group">
							<label class="label">Buscar por número de chasis</label>
							<div class="input-group">
								<input type="text" 
									class="form-control" 
									placeholder="Número de chasis" 
									v-model="searchTerms"
									@keyup="touched=false"
									@keyup.enter="searchCars()"
									>
								<div class="input-group-append">
									<button @click="searchCars()" class="btn btn-outline-secondary" type="button">Buscar</button>
								</div>
							</div>
						</div>

						<div class="alert alert-warning" v-if="touched && !loading && cars.length==0">
							No se han encontrado vehículos con número de chasis {{searchTerms}}
						</div>

						<table class="table mt-2 mb-4" v-if="cars.length>0">
							<tr class="table-head">
								<td>Chasis</td>
								<td>Vehículo</td>
								<td>Cliente</td>
							</tr>
							<tr v-for="item of cars" :key="item.id" @click="selectCar(item.id)">
								<td>{{item.chassis_number}}</td>
								<td>
									<div class="tc">
										<span class="text-primary">{{item.brand.title}}</span>
										<span >{{item.model}}</span>
									</div>
								</td>
								<td>
									<div class="tc">
										<span class="text-primary">{{item.client.name}}</span>
										<span >{{item.client.business_name}}</span>
									</div>
								</td>
							</tr>
						</table>


					</div>



				</div>
			</div>
		</div>

		<!-- <div class="footer">
			<div class="container">
				<div class="btn btn-block btn-lg btn-primary" @click="openScan()">Escanear</div>
			</div>
		</div> -->

		<div class="code-reader transition" v-if="showReader">
			<div class="btn " @click="closeScan()" v-if="opened"><i class="icon icon-close invert"></i></div>
			<div class="layer transition" v-if="opened"></div>
			<qrcode-stream @decode="onDecode" @init="onInit" ref="rootElement"></qrcode-stream>
		</div>

	</div>

	<RegisterCarCode ref="registerCarCode"></RegisterCarCode>

</b-modal>

</template>

<script>
import gql from 'graphql-tag'
import { QrcodeStream } from 'vue-qrcode-reader'
import Loader from '@/components/Loader'
import RegisterCarCode from '@/views/controls/RegisterCarCode'

export default {
	name: 'readCode',
	components:{
		Loader,
		QrcodeStream,
		RegisterCarCode
	},
	props:['title'],
	data () {
		return {
			loading: false,
			show: false,
			opened :false,
			touched :false,
			showReader: false,
			showSearch: false,
			cars:[],
			searchTerms:null,
			beep: new Audio(require('@/assets/beep.mp3')),
			loadCarById: null,
			settings: {}
		}
	},
	beforeMount(){
		this.loadSettings()
	},
	methods:{
		setCarReading(){
			this.$refs.registerCarCode.open()
		},
		open(carId) {
			this.show = true
			if(carId>0){
				this.loadCarById = carId // si tengo este id, es porqe el vehiculo que tengo que leer debe ser ese.
				this.openScan()
			}
			this.$bvModal.show('modalReadCode')
		},
		close () {
			this.loadCarById = null
			this.searchTerms = null
			this.showReader = false
			this.showSearch = false
			this.$bvModal.hide('modalReadCode')
		},
		openScan(){
			this.showReader = true
		},
		closeScan(){
			if(this.loadCarById!=null){
				this.close()
			}
			this.showReader = false
			this.opened = false
		},
		openSearch(){
			this.showSearch = true
		},
		async  onInit(promise){
			try{
				await promise
				this.opened = true
			} catch(error){
				console.log(error)
			}
		},
		onDecode(data){
			this.beep.play()
			this.closeScan()
			data =  JSON.parse(data)
			if(this.loadCarById!=null){
				if(this.loadCarById==data.id){
					this.loadCar(data.id)
				}else{
					this.$toast.error('El código no corresponde al vehículo  seleccionado')
					this.close()
					return false 
				}
			}
			this.loadCar(data.id)
		},
		searchCars(){
			this.touched = true
			this.loading = true
			this.$apollo.query({
				query: gql`query ($chassis_number: String!) {
					carsAll (chassis_number: $chassis_number) {
						id
						chassis_number
						model
						brand{
							title
						}
						client{
							name
							business_name
						}
					}
				}`,
				variables: {
					chassis_number: this.searchTerms,
				},
				fetchPolicy: 'no-cache'
			})
			.then((data) => {
				this.loading = false
				this.cars = data.data.carsAll
			})
		},
		selectCar(id){
			this.$router.push(`/control/${id}`)
		},
		loadCar(car_id){
			this.loading = true
			this.$apollo.query({
				query: gql`query ($id: ID!) {
					car (id: $id) {
						id
						chassis_number
					}
				}`,
				variables: {
					id: car_id
				},
				fetchPolicy: 'no-cache'
			})
			.then((data) => {
				if(!data.data.car){
					this.$toast.error('No se ha encontrado un vehículo con ese código')
				}else{
					this.$router.push(`/control/${data.data.car.id}`)
				}
				this.loading = false
			})
		},
		loadSettings(){
			this.$apollo.query({
				query: gql`query {
					settings{
						enableCounts
					}
				}`,
				fetchPolicy: 'no-cache'
			})
			.then((data) => {
				this.settings = data.data.settings;
			});
		},
	}
}


</script>

<style scoped lang="scss">
.code-reader{
	width:100%;
	height:100%;
	z-index:100;
	top:0px;
	position:fixed;

	.btn{
		position: absolute;
		top: 10px;
		right: 10px;
		z-index: 11;
		font-size:18px;
		color:	#fff;
	}
}
.layer{
	position:absolute;
	top:0;
	width:100%;
	height:100%;
	background:rgba(155,155,155,0.6) ;	
	z-index: 10;
	-webkit-clip-path: polygon(0% 0%, 0% 100%, 15% 100%, 15% 15%, 85% 15%, 85% 85%, 15% 85%, 15% 100%, 100% 100%, 100% 0%);
	clip-path: polygon(0% 0%, 0% 100%, 15% 100%, 15% 15%, 85% 15%, 85% 85%, 15% 85%, 15% 100%, 100% 100%, 100% 0%);
}
</style>
